export const stringLengthChecker = (value = "", lengthDiffMax = 1) => (ref) => {
    const diff = value.length - ref.length;
    return diff <= lengthDiffMax && diff >= -lengthDiffMax;
};
